module.exports = __webpack_public_path__ + "img/drone-lago-di-garda-2.5d2c33cd.jpg";